import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api/index';
import qs from 'query-string';

type PayloadType = 'initApp' | 'setState' | 'newSearch';
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})

export const newSearch: ActionCreator<void> = (payload) => ({
	type: 'newSearch',
	payload
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const newSearchAction: ActionHandler<void> = ({ commit, state }) => {
	commit({
		type: 'setLoading',
		payload: true,
	});
	const categoriesFilter = state.searchResult.filter.categories 
		&& state.searchResult.filter.categories.length > 0 
		? state.searchResult.filter.categories.join(',') 
		: '';
	api.search(state.endpoints.search, state.searchResult.query, categoriesFilter, state.searchResult.page.toString())
		.then(res => {
			commit({
				type: 'setSearchResultItems',
				payload: res?.items || [],
			})
			commit({
				type: 'setTotal',
				payload: res?.total || 0,
			})
			commit({
				type: 'setCanLoadMore',
				payload: res.canLoadMore || false,
			})
			commit({
				type: 'setLoading',
				payload: false,
			})
		});
	const location = window.location;
	const params: any = {};
	if(categoriesFilter) {
		params.categories = categoriesFilter;
	}
	if(state.searchResult.query) {
		params.query = state.searchResult.query;
	}
	if(state.searchResult.page) {
		params.page = state.searchResult.page;
	}
	const url = `${location.protocol}//${location.host}${location.pathname}?` + qs.stringify(params);
	window.history.replaceState({}, document.title, url);
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	newSearch: newSearchAction,
}

export default actions;
